import Store from 'lightningjs-redux';
import { getWatchAgainFeature } from '../../../logic/features/features.selectors';

import { getNextVideoItem, getCurrentVideoItem } from '../../../logic/player/video.selectors';

const mapControllers = instance => ({
  currentVideo: {
    selector: getCurrentVideoItem,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.currentVideo = value;
    },
  },
  nextVideo: {
    selector: getNextVideoItem,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.nextVideo = value;
    },
  },
  currentVideoAvailable: {
    selector: getWatchAgainFeature,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.watchAgain = value;
    },
  },
});

export default Store.control(mapControllers);
